<template>
    <div>
        <header class="main_header_arae">
            <div class="navbar-area is-sticky">
                <div class="main-responsive-nav">
                    <div class="container">
                        <div class="main-responsive-menu mean-container">
                            <nav class="navbar">
                                <div class="container">
                                    <div class="logo">
                                        <a :href="redirect_url">
                                            <img src="@/assets/img/logo.png" alt="logo" height="60">
                                        </a>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="main-navbar">
                    <nav class="navbar navbar-expand-md navbar-light">
                        <a class="navbar-brand" :href="redirect_url">
                            <img src="@/assets/img/logo.png" alt="logo" height="60">
                        </a>
                        <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                            <ul class="navbar-nav">
                                <li class="nav-item m-0">
                                    <button type="button" role="button" class="btn btn-default pl-0 pr-0"
                                        id="chat-circle">
                                        <span class="filter-option pull-left">
                                            <div class="cur-con">
                                                <img src="@/assets/img/icons/message.png" width="24" class="mb-1">
                                                <span class="ml10 mr10 font-14">
                                                    {{ $t('Contact Us') }}
                                                </span>
                                            </div>
                                        </span>&nbsp;
                                    </button>
                                </li>
                                <li class="nav-item">
                                    <button type="button" data-toggle="dropdown" role="button"
                                        class="btn dropdown-toggle btn-default btn-lang">
                                        <span class="filter-option pull-left">
                                            <div class="cur-con">
                                                <span :class="language == 'ar' ? 'flag flag-sa' : 'flag flag-us'">
                                                </span>
                                                <span class="ml10 mr10 font-14">
                                                    {{ language == 'ar' ? 'Arabic' : 'English' }}
                                                </span>
                                            </div>
                                        </span>&nbsp;
                                    </button>
                                    <ul class="dropdown-menu lang inner">
                                        <li v-if="language == 'en'">
                                            <a @click="setLocale('ar')" href="javascript:void(0);">
                                                <div class="cur-con">
                                                    <span class="flag flag-sa"></span>
                                                    <span class="ml10 mr10">Arabic</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-if="language == 'ar'">
                                            <a @click="setLocale('en')" href="javascript:void(0);">
                                                <div class="cur-con">
                                                    <span class="flag flag-us"></span>
                                                    <span class="ml10 mr10">English</span>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            redirect_url: null,
            language: null,
        }
    },
    methods: {
        setLocale(lang) {
            if (this.language != lang) {
                if (this.language == 'en') {
                    localStorage.setItem("locale", 'ar');
                } else {
                    localStorage.setItem("locale", 'en');
                }
                window.location.reload();
            }
        }
    },
    mounted() {
        this.redirect_url = localStorage.getItem("redirect_url");
        this.language = localStorage.getItem("locale") ?? 'en';
        this.$i18n.locale = this.language;

        if (this.language == 'ar') {
            document.body.classList.add("rtl");
        } else {
            document.body.classList.remove("rtl");
        }

        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('hamburger-toggle')) {
                e.target.children[0].classList.toggle('active');
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 100px;
    padding: 0 0;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, .15);
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);

    li {
        display: flex;
    }
}
.open .dropdown-menu {
    display: block;
}
.dropdown-menu>li>a {
    display: block;
    padding: 0;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #000 !important;
    white-space: nowrap;
}
.mr10 {
    margin-right: 10px !important;
}
.ml10 {
    margin-left: 10px !important;
}
.flag {
    display: inline-block;
    width: 16px;
    height: 11px;
    background: url('~@/assets/flags/flags.png') no-repeat;
}
.dropdown-toggle::after {
    content: none;
}
</style>